// removed by extract-text-webpack-plugin
module.exports = {"slide":"_34pqt9RDU21PBHPWNcLI5u","compact":"_18znKLrWqZl3bJiF4spDU8","image":"_1F64aDzZdfWzRYv7gYpcGP","prev":"_1Yi1joFBu4LM-C7o6Ym1Kd","next":"_2jiwJB8ZkA3GFwhOWwQ40f","featureActive":"_2gS8I19kbvKBfNEvVlHmSv","feature":"_1IrtAMmqPZDxH7NglnJABA","timeline":"_2IZw9JYyGfx9fG21l-Ogdl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectCardSlider/ProjectCardSlider.module.scss
// module id = 796
// module chunks = 0